import Location from './Location'

export default Location